module.exports = __webpack_public_path__ + "img/stage_bg.9d84122.jpg";